import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { environment } from './../../../../../environments/environment';
import { Parametro } from './../../../../shared/service-base/parametro';
import { ServiceBase } from './../../../../shared/service-base/ServiceBase';

@Injectable()
export class CategoriaOsService
  extends ServiceBase {
  private baseUrlService: string;

  constructor(
    http: HttpClient,
    router: Router
  ) {
    super(http, router);
    this.baseUrlService = environment.URL_API
  }

  protected getURL(): string {
    return `${this.baseUrlService}/categoria_os`
  }

  private gerarListaParametros(categoria, tipo): any[] {
    const parametros: Parametro[] = [];

    const itemCategoria = new Parametro('categoria', categoria);
    parametros.push(itemCategoria);

    const itemTipo = new Parametro('tipo', tipo);
    parametros.push(itemTipo);

    return parametros;
  }

  incluirTipoCategoria(path: string, categoria: number, tipo: number): Promise<any> {
    const parametros = this.gerarListaParametros(categoria, tipo);
    return this.atualizar({}, parametros);
  }

  removerTipoCategoria(path: string, categoria: number, tipo: number): Promise<any> {
    const parametros = this.gerarListaParametros(categoria, tipo);
    return this.remover(parametros);
  }

}
